import React, { useState } from "react";

export default function ImageToBase64(props) {
    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        const base64 = await convertToBase64(file);
        props.onSelect(base64);
    };

    const handleFileRemove = async (e) => {        
        props.onSelect("");
    };

    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    return (
        <div>
            <div>
                <input
                    style={{ display: "none" }}
                    type="file"
                    label={props.logoFor}
                    name={props.logoFor}
                    id={props.logoFor}
                    accept=".jpeg, .png, .jpg"
                    onChange={(e) => handleFileUpload(e)}
                />
                <div style={{ display: "inline-flex", textAlign: "center" }}>
                    <label style={{ fontSize: '15px', fontWeight: 'bold', color: 'blue', marginTop: '9px' }} htmlFor={props.logoFor} id={props.logoFor} className="btn global-add mr-2">{props.selectText}</label>
                    {props.removeText &&
                    <label style={{ fontSize: '15px', fontWeight: 'bold', color: 'blue', marginTop: '9px' }} id={props.logoFor} className="btn global-remove" onClick={(e)=> handleFileRemove(e)}>{props.removeText}</label>}
                </div>
            </div>
        </div>
    );
}